module.exports = __webpack_public_path__ + "static/media/cq_flag b.ed95140c.svg";